import { cls } from "../../NUI/utils";

export function PointerLabel({label, width, position, dir="right"}) {
	return  (
        <div className={cls("h-[7.12px] absolute flex justify-between items-center z-10", position, dir==="left"&&"flex-row-reverse")}>
            <span className="bg-is2-blue text-white text-xs xs:text-sm rounded-sm px-1">{label}</span>
            <div style={{width}} className="h-[1px] bg-is2-blue"></div>
            <img alt="Blue Arrow" src="https://storage.googleapis.com/instant-med-public/v2/arrow-blue.svg" className={cls("h-[7.12px]", dir==="left"&&"rotate-[180deg]")}/>
        </div>
    )
}
